module.exports = __webpack_public_path__ + "static/img/5257_phase_function_Paper_PointsHejduk_Prediction.88f01af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5257_phase_function_Paper_PointsHejduk_Prediction.png
// module id = s76Q
// module chunks = 0